import { render, staticRenderFns } from "./gptHole.vue?vue&type=template&id=d47afd74&scoped=true"
import script from "./gptHole.vue?vue&type=script&lang=js"
export * from "./gptHole.vue?vue&type=script&lang=js"
import style0 from "./gptHole.vue?vue&type=style&index=0&id=d47afd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47afd74",
  null
  
)

export default component.exports